var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWave1 = function SvgWave1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 266"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M1440 265.999H0C351.512 258.797 1207.09-194.799 1440 99.5v166.499"
  })));
};
export default SvgWave1;